if($('.loan-option-navigation-container').length) {

    // new loan navigation
    let typeSelection = $('.loan-option-type-selection'),
        navItem = $('.loan-option-navigation-item'),
        selectedLoanType = 'farm-loan';

    typeSelection.on('click', function () {
        selectedLoanType = $(this).data('type');

        if($(this).parent().hasClass('selected')) {
            $(this).parent().removeClass('selected');

            if($(window).width() <= 768) {
                $(this).parent().find('.mobile-state-options-container').slideDown();
            }
        } else {
            typeSelection.parent().removeClass('selected');
            $(this).parent().addClass('selected');

            if($(window).width() <= 768) {
                $(this).parent().parent().find('.mobile-state-options-container').not($(this).parent().find('.mobile-state-options-container')).slideUp();
                $(this).parent().find('.mobile-state-options-container').slideDown();
            }
        }
    });

    navItem.on('click', function (e) {
        window.location.href = constructUrlNew(selectedLoanType, $(this).data('state'));
    });

    function constructUrlNew(type, location) {

        // Both Empty (Should not be able to be achieved)
        if(type === "" && location === "") return '';

        // Only a type selected
        if(type !== "" && location === "") return '/financing/' + type + 's/';

        // Only a location selected
        if(type === "" && location !== "") return '/financing/' + location + '/';

        // Fallback, both selected
        return '/financing/' + location + '-' + type + 's/';

    }

}

if($(".contact-cards").length) {

    function sizeContactCards() {
        $('.contact-cards .bio-img').each(function () {
            $(this).css('padding-bottom', $(this).find('img').height());
        });
    }

    $(document).ready(function () { sizeContactCards(); });
    $(window).on('load resize', function () {
        sizeContactCards();
    });


    let brokerContactButton = $('.broker-contact-button'),
        brokerContactModal = $('#broker-contact-modal'),
        brokerContactForm = $('#broker-contact-form'),
        brokerContactThankYouInput = $('#broker-contact-thank-you'),
        brokerContactThankYouModal = $('#broker-contact-thank-you-modal');

    brokerContactButton.on('click', function () {
        $('#contact-broker-id').val($(this).data('broker-id'));
        $('#contact-broker-label').val($(this).data('broker-label'));
        $('#contact-broker-heading').html($(this).data('broker-label'));
    });

    if (brokerContactModal.length) {
        brokerContactForm.validate({
            rules: {
                contact_first_name: "required",
                contact_last_name: "required",
                contact_email_address: { required: true, email: true },
                contact_details: "required"
            },
            submitHandler: function (form) {
                grecaptcha.execute();
                window.dataLayer.push({
                    event: 'broker-contact-submit',
                    brokerLabel: $('#contact-broker-label').val(),
                    propertyLabel: $('#contact-property-label').val(),
                });
            }
        });
    }

    if (brokerContactThankYouInput.length) {
        brokerContactThankYouModal.modal('show');
    }
}

if($('.financing-page-selector').length) {

    $('.financing-page-selector').each(function () {

        let typeDropdownTrigger = $(this).find('.selector-dropdown-trigger-type'),
            locationDropdownTrigger = $(this).find('.selector-dropdown-trigger-location'),
            loanSearchFormSubmit = $(this).find('.loan-search-form-submit'),
            selectedType = $(this).find('.finance-selected-type-value').val(),
            selectedLocation = $(this).find('.finance-selected-state-value').val(),
            typeDropdownItems = $(this).find('.selector-dropdown-item-type'),
            locationDropdownItems = $(this).find('.selector-dropdown-item-location'),
            typeDropdown = $('.selector-dropdown-type'),
            locationDropdown = $('.selector-dropdown-location');

        typeDropdownTrigger.on('click', function (e) {
            e.stopPropagation();

            // Close location dropdown if open
            if(locationDropdown.hasClass('is-active')) {
                locationDropdown.removeClass('is-active');
                locationDropdown.addClass('is-hiding');
                setTimeout(function () {
                    locationDropdown.addClass('d-none');
                }, 350);
            }

            if(typeDropdown.hasClass('is-active')) {
                typeDropdown.removeClass('is-active');
                typeDropdown.addClass('is-hiding');
                setTimeout(function () {
                    typeDropdown.addClass('d-none');
                }, 350);
            } else {
                typeDropdown.addClass('is-active');
                typeDropdown.removeClass('d-none');
                setTimeout(function () {
                    typeDropdown.removeClass('is-hiding');
                }, 50);
            }

        });

        locationDropdownTrigger.on('click', function (e) {
            e.stopPropagation();

            // Close type dropdown if open
            if(typeDropdown.hasClass('is-active')) {
                typeDropdown.removeClass('is-active');
                typeDropdown.addClass('is-hiding');
                setTimeout(function () {
                    typeDropdown.addClass('d-none');
                }, 350);
            }

            if(locationDropdown.hasClass('is-active')) {
                locationDropdown.removeClass('is-active');
                locationDropdown.addClass('is-hiding');
                setTimeout(function () {
                    locationDropdown.addClass('d-none');
                }, 350);
            } else {
                locationDropdown.addClass('is-active');
                locationDropdown.removeClass('d-none');
                setTimeout(function () {
                    locationDropdown.removeClass('is-hiding');
                }, 50);
            }

        });

        typeDropdownItems.on('click', function (e) {
            e.stopPropagation();
            typeDropdownTrigger.find('.selector-dropdown-trigger-button').html(($(this).data('type') !== "") ? $(this).data('type') : 'Land Loan');
            selectedType = $(this).data('type-slug');

            if(typeDropdown.hasClass('is-active')) {
                typeDropdown.removeClass('is-active');
                typeDropdown.addClass('is-hiding');
                setTimeout(function () {
                    typeDropdown.addClass('d-none');
                }, 350);
            }

            formCheck();
        });

        locationDropdownItems.on('click', function (e) {
            e.stopPropagation();
            locationDropdownTrigger.find('.selector-dropdown-trigger-button').html(($(this).data('location') !== "") ? $(this).data('location') : 'State');
            selectedLocation = $(this).data('location-slug');

            if(locationDropdown.hasClass('is-active')) {
                locationDropdown.removeClass('is-active');
                locationDropdown.addClass('is-hiding');
                setTimeout(function () {
                    locationDropdown.addClass('d-none');
                }, 350);
            }

            formCheck();
        });

        function formCheck() {

            positionDropdowns();

            if(selectedType === "" && selectedLocation === "") {
                loanSearchFormSubmit.addClass('disabled');
            } else {
                loanSearchFormSubmit.removeClass('disabled');
            }

        }

        formCheck();

        loanSearchFormSubmit.popover();

        loanSearchFormSubmit.on('click', function () {

            if(!$(this).hasClass('disabled')) {
                // Redirect the user to the provided page
                window.location.href = constructUrl();
                loanSearchFormSubmit.popover('hide');
            } else {
                loanSearchFormSubmit.popover('show');

                setTimeout(function () {
                    loanSearchFormSubmit.popover('hide');
                }, 2000);
            }

        });

        function constructUrl() {

            // Both Empty (Should not be able to be achieved)
            if(selectedType === "" && selectedLocation === "") return '';

            // Only a type selected
            if(selectedType !== "" && selectedLocation === "") return '/financing/' + selectedType + 's/';

            // Only a location selected
            if(selectedType === "" && selectedLocation !== "") return '/financing/' + selectedLocation + '/';

            // Fallback, both selected
            return '/financing/' + selectedLocation + '-' + selectedType + 's/';

        }

        function positionDropdowns() {

            let typeTriggerWidth = typeDropdownTrigger.outerWidth(),
                locationTriggerWidth = locationDropdownTrigger.outerWidth(),
                typeDropdownWidth = typeDropdown.actual('outerWidth'),
                locationDropdownWidth = locationDropdown.actual('outerWidth'),
                typeOffset = 0,
                locationOffset = 0;

            if(parseInt(typeTriggerWidth) > parseInt(typeDropdownWidth)) {
                typeOffset = (typeTriggerWidth - typeDropdownWidth) / 2;
            } else {
                typeOffset = 0 - ((typeDropdownWidth - typeTriggerWidth) / 2);
            }

            if(parseInt(locationTriggerWidth) > parseInt(locationDropdownWidth)) {
                locationOffset = (locationTriggerWidth - locationDropdownWidth) / 2;
            } else {
                locationOffset = 0 - ((locationDropdownWidth - locationTriggerWidth) / 2);
            }

            typeDropdown.css('margin-left', typeOffset);
            locationDropdown.css('margin-left', locationOffset);

        }

        $('body').imagesLoaded(function () {
            setTimeout(function () {
                positionDropdowns();
            }, 1000);
        });

        $('body').on('click', function () {
            if(typeDropdown.hasClass('is-active')) {
                typeDropdown.removeClass('is-active');
                typeDropdown.addClass('is-hiding');
                setTimeout(function () {
                    typeDropdown.addClass('d-none');
                }, 350);
            }

            if(locationDropdown.hasClass('is-active')) {
                locationDropdown.removeClass('is-active');
                locationDropdown.addClass('is-hiding');
                setTimeout(function () {
                    locationDropdown.addClass('d-none');
                }, 350);
            }
        });

    });

}

if ($("#get-started").length) {

    $('#get-started-email-form').validate({
        rules: {
            get_started_email: { required: true, email: true },
        }
    });

    $('#get-started-email-form').submit(function (e) {
        e.preventDefault();
        if ($('#get-started-email-form').valid()) {
            var email = $('#get_started_email').val();

            window.helpers.gaEvent('Contact:Finance', 'short-finance-form-submitted', '');
            window.helpers.gaEvent('Form Submission', 'finance-get-started', '');

            window.location.href = '/finance-get-started/?email=' + email;

            document.getElementById('get_started_email_address').value = email;

            // $('.get-started-form-container').hide().removeClass('d-none').slideDown();
            // $('.email-form-container').hide();
        }
    });

    $('#get_started_state').on('change', function () {
        if ($(this).val() === "other") {
            $('#form-state-other-hidden-option').removeClass('d-none');
        } else {
            $('#form-state-other-hidden-option').addClass('d-none');
        }
    });

    // TODO working on the form validation here
    $('#get-started-form').validate({
        rules: {
            get_started_first_name: "required",
            get_started_email_address: { required: true, email: true },
            get_started_property_description: "required",
            get_started_requested_loan_amount: "required",
            get_started_state: "required",
            get_started_county: "required"
        },
        submitHandler: function (form) {
            grecaptcha.execute();
        }
    });

}

if ($('#gform_4').length) {

    $('#gform_4').on('submit', function () {
        window.helpers.gaEvent('Contact:Finance', 'long-finance-form-submitted', '');
        window.helpers.gaEvent('Form Submission', 'finance-full-form', '');
    });

    if(window.helpers.getQueryVariable('state')) {
        $('#input_4_14').val(window.helpers.getQueryVariable('state'));
    }

}

if($('.financing-explore-your-options').length) {

    let link = $('.financing-explore-your-options').find('a').first();

    console.log(link.attr('href'));

    // var string = "foo",
    //     substring = "oo";

    if(link.attr('href').indexOf('/financing/your-options') !== -1) {
        if(link.attr('href').indexOf('?state=') !== -1) {} else {
            let stateAppend = $("#active-state-for-options-form").val();
            link.attr('href', link.attr('href') + '?state=' + stateAppend);
        }
    }

}
